import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["required", "aria-required"]
const _hoisted_2 = ["required", "aria-required"]
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = ["required", "aria-required"]
const _hoisted_5 = {
  key: 0,
  class: "notice-box",
  id: "verwalterTelefonInfo"
}
const _hoisted_6 = {
  key: 0,
  class: "notice-box",
  id: "verwalterMobilInfo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_Anrede = _resolveComponent("Anrede")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_adresse = _resolveComponent("adresse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ueberschrift, { titel: "Verwalter" }),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("Anrede und Titel")
          ])),
          _: 1,
          __: [13]
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_Anrede, {
              id: "verwalterAnrede",
              fehler: _ctx.fehler,
              "ist-verwalter": true,
              modelValue: _ctx.piniaStore.state.personendaten.verwalter.anrede,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.anrede) = $event)),
              required: true,
              ariaLabel: "Anrede des Verwalters"
            }, null, 8, ["fehler", "modelValue"])
          ]),
          _: 1
        }),
        (!_ctx.isOrganisation)
          ? (_openBlock(), _createBlock(_component_zelle, {
              key: 0,
              breite: 3
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "verwalterTitel",
                  name: "verwalterTitel",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.titel) = $event)),
                  class: "c-form-control-select",
                  "data-cy": "verwalterTitel",
                  "aria-label": "Titel"
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("option", { value: "" }, "Titel", -1),
                  _createElementVNode("option", { value: "Dipl.Ing." }, "Dipl. Ing.", -1),
                  _createElementVNode("option", { value: "Dr." }, "Dr.", -1),
                  _createElementVNode("option", { value: "Prof.Dr." }, "Prof. Dr.", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.piniaStore.state.personendaten.verwalter.titel]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler?.verwalterTitel,
                  "reduzierter-abstand": true
                }, null, 8, ["fehler-text"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isOrganisation)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, null, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("Name der Firma")
              ])),
              _: 1,
              __: [15]
            }),
            _createVNode(_component_zelle, { breite: 6 }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "organisation",
                  name: "organisation",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.organisation) = $event)),
                  class: "c-form-control__input",
                  "data-cy": "vermittlerOrganisation",
                  placeholder: "Firma",
                  minlength: "2",
                  maxlength: "40",
                  required: "",
                  "aria-required": "true",
                  "aria-label": "Name der Firma",
                  "data-fehlermeldung": 'Bitte geben Sie den Namen der Firma ein (2-40 Zeichen).'
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.piniaStore.state.personendaten.verwalter.organisation,
                    void 0,
                    {
                      lazy: true,
                      trim: true
                    }
                  ]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler?.organisation
                }, null, 8, ["fehler-text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => [
            _cache[16] || (_cache[16] = _createTextVNode("Vorname und Name ")),
            (_ctx.isFirma)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" (optional)")
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [16]
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "verwalterVorname",
              name: "verwalterVorname",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.vorname) = $event)),
              class: "c-form-control__input",
              "data-cy": "verwalterVorname",
              placeholder: "Vorname",
              minlength: "2",
              maxlength: "40",
              required: !_ctx.isFirma,
              "aria-required": !_ctx.isFirma,
              "aria-label": "Vorname des Verwalters",
              "data-fehlermeldung": "Bitte geben Sie den Vornamen ein (2-40 Zeichen)."
            }, null, 8, _hoisted_1), [
              [
                _vModelText,
                _ctx.piniaStore.state.personendaten.verwalter.vorname,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler?.verwalterVorname
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "verwalterNachname",
              name: "verwalterNachname",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.nachname) = $event)),
              class: "c-form-control__input",
              "data-cy": "verwalterNachname",
              placeholder: "Name",
              minlength: "2",
              maxlength: "40",
              required: !_ctx.isFirma,
              "aria-required": !_ctx.isFirma,
              "aria-label": "Nachname des Verwalters",
              "data-parsley-combined-name-length": "40",
              "data-fehlermeldung": "Bitte geben Sie den Nachnamen ein (2-40 Zeichen)."
            }, null, 8, _hoisted_2), [
              [
                _vModelText,
                _ctx.piniaStore.state.personendaten.verwalter.nachname,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler?.verwalterNachname
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_adresse, {
      fehler: _ctx.fehler,
      plz: _ctx.piniaStore.state.personendaten.verwalter.adresse.plz,
      "onUpdate:plz": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.plz) = $event)),
      ort: _ctx.piniaStore.state.personendaten.verwalter.adresse.ort,
      "onUpdate:ort": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.ort) = $event)),
      strasse: _ctx.piniaStore.state.personendaten.verwalter.adresse.strasse,
      "onUpdate:strasse": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.strasse) = $event)),
      hausnummer: _ctx.piniaStore.state.personendaten.verwalter.adresse.hausnummer,
      "onUpdate:hausnummer": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.hausnummer) = $event)),
      "zu-pruefen": _ctx.piniaStore.state.personendaten.verwalter.adresse.zuPruefen,
      "onUpdate:zuPruefen": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.zuPruefen) = $event)),
      feldNamen: {
      plz: 'verwalterPlz',
      ort: 'verwalterOrt',
      strasse: 'verwalterStrasse',
      hausnummer: 'verwalterHausnummer',
    },
      "session-marker": "verwalter",
      ref: "adresseRef"
    }, null, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "zu-pruefen"]),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => [
            _createTextVNode("E-Mail " + _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "(optional) " : ""), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_zelle, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "verwalterEmail",
              name: "verwalterEmail",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.email) = $event)),
              class: "c-form-control__input",
              "data-cy": "verwalterEmail",
              placeholder: "E-Mail",
              minlength: "2",
              maxlength: "60",
              required: !_ctx.piniaStore.state.isMakler,
              "aria-required": !_ctx.piniaStore.state.isMakler,
              "aria-label": "Email des Verwalters",
              "data-fehlermeldung": "Bitte geben Sie die E-Mail-Adresse ein (2-60 Zeichen)."
            }, null, 8, _hoisted_3), [
              [
                _vModelText,
                _ctx.piniaStore.state.personendaten.verwalter.email,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler?.verwalterEmail
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_zeile, { class: "o-grid" }, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": !_ctx.piniaStore.state.isMakler,
          "info-box-id": "verwalterTelefonInfo"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Telefon " + _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "(optional) " : ""), 1)
          ]),
          _: 1
        }, 8, ["zeige-info"]),
        _createVNode(_component_zelle, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "verwalterTelefon",
              name: "verwalterTelefon",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.telefon) = $event)),
              class: "c-form-control__input",
              placeholder: "Telefon",
              "data-cy": "verwalterTelefon",
              minlength: "6",
              maxlength: "30",
              required: _ctx.eineTelefonnummerMussAngegebenWerden,
              "aria-required": _ctx.eineTelefonnummerMussAngegebenWerden,
              "aria-label": "Telefonnummer des Verwalters",
              "data-checktelefonnummer": "true"
            }, null, 8, _hoisted_4), [
              [
                _vModelText,
                _ctx.piniaStore.state.personendaten.verwalter.telefon,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler?.verwalterTelefon
            }, null, 8, ["fehler-text"]),
            (_ctx.istSichtbar('verwalterTelefonInfo'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[17] || (_cache[17] = [
                  _createElementVNode("p", null, " Bitte geben Sie die Telefonnummer an, unter der Sie tagsüber erreichbar sind. Ihre Telefonnummer wird nicht zu Werbezwecken verwendet, sondern lediglich für Rückfragen unserer Mitarbeiter/innen genutzt. ", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": !_ctx.piniaStore.state.isMakler,
          "info-box-id": "verwalterMobilInfo"
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode(" Mobiltelefon")
          ])),
          _: 1,
          __: [18]
        }, 8, ["zeige-info"]),
        _createVNode(_component_zelle, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "verwalterMobile",
              name: "verwalterMobile",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.mobil) = $event)),
              class: "c-form-control__input",
              "data-cy": "verwalterMobile",
              placeholder: "Mobiltelefon",
              minlength: "6",
              maxlength: "30",
              "aria-label": "Mobilfunkrufnummer des Verwalters",
              "data-checkmobilnummer": "true"
            }, null, 512), [
              [
                _vModelText,
                _ctx.piniaStore.state.personendaten.verwalter.mobil,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler?.verwalterMobile
            }, null, 8, ["fehler-text"]),
            (_ctx.istSichtbar('verwalterMobilInfo'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[19] || (_cache[19] = [
                  _createElementVNode("p", null, " Ihre Mobiltelefonnummer wird nicht zu Werbezwecken verwendet, sondern lediglich für Rückfragen unserer Mitarbeiter/innen genutzt. ", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}